import{l as i}from"./ninox-components-GQTCIGTF.js";import n,{keyframes as o}from"styled-components";var r=o`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`,e=o`
  from {
    transform: rotate(130deg);
  }
  to {
    transform: rotate(-10deg);
  }
`,a=o`
  from {
    transform: rotate(-130deg);
  }
  to {
    transform: rotate(10deg);
  }
`,s=n.div`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    vertical-align: middle;
    position: relative;
    flex: 0 0 auto;
    width: ${({size:t})=>t||i.xxs};
    height: ${({size:t})=>t||i.xxs};

    --_inline-size: calc(${({size:t})=>t||i.xxs} * 5 / 6);

    color: ${({color:t})=>t};
    pointer-events: none;
    contain: layout size paint;

    .mirrored {
        transform: scaleY(-1);
    }

    .outer {
        width: var(--_inline-size);
        height: var(--_inline-size);
        box-sizing: border-box;

        transform-origin: 50% 50%;

        animation-duration: ${({animationDuration:t})=>(t||1)*7/8}s;
        animation-timing-function: linear;
        animation-iteration-count: infinite;
        animation-fill-mode: both;
    }

    .inner {
        position: absolute;
        width: var(--_inline-size);
        height: var(--_inline-size);

        animation-duration: ${({animationDuration:t})=>t||1}s;
        animation-timing-function: ease-in-out;
        animation-iteration-count: infinite;
        animation-fill-mode: both;
    }

    .marker {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        overflow: hidden;

        :after {
            content: '';

            position: absolute;
            width: 200%;
            height: 100%;
            box-sizing: border-box;
            border-style: solid;
            border-color: transparent;
            border-radius: 50%;
            border-width: ${({borderWidth:t})=>t};

            animation-duration: ${({animationDuration:t})=>(t||1)*.75}s;
            animation-timing-function: ease-in-out;
            animation-iteration-count: infinite;
            animation-direction: alternate;
            animation-fill-mode: both;
        }
    }

    .marker.left {
        right: 50%;

        :after {
            left: 0;
            right: -100%;
            border-top-color: currentColor;
            border-left-color: currentColor;
        }
    }

    .marker.right {
        left: 50%;

        :after {
            left: -100%;
            right: 0;
            border-top-color: currentColor;
            border-right-color: currentColor;
        }
    }

    &[aria-busy='true'] {
        .marker.left:after {
            animation-name: ${e};
        }
        .marker.right:after {
            animation-name: ${a};
        }
        .inner,
        .outer {
            animation-name: ${r};
        }
    }
`;export{s as a};
//# sourceMappingURL=ninox-components-LX2IQEKF.js.map